import React from 'react';
import Chart from 'react-apexcharts';

const AttendanceChart = ({ AttendanceChartData }) => {

  // Step 1: Generate full days array based on your data
  const startDate = new Date(Math.min(...AttendanceChartData.map(d => d.date)));
  const endDate = new Date(Math.max(...AttendanceChartData.map(d => d.date)));
  const daysInMonth = [];

  console.log(startDate);
  
  let current = new Date(startDate);
  current.setHours(0, 0, 0, 0);
  while (current <= endDate) {
    daysInMonth.push(current.getDate());
    current.setDate(current.getDate() + 1);
  }

  // Step 2: Create a map of your data by day timestamp
  const dataMap = {};
  AttendanceChartData.forEach(item => {
    const ts = new Date(item.date).setHours(0, 0, 0, 0);
    dataMap[ts] = item.present;
  });

  // Step 3: Fill missing days with 0
  const presentData = [];
  current = new Date(startDate);
  current.setHours(0, 0, 0, 0);
  while (current <= endDate) {
    const ts = current.getTime();
    presentData.push(dataMap[ts] || 0);
    current.setDate(current.getDate() + 1);
  }

  const options = {
    chart: { type: 'bar', height: 400, toolbar: { show: false } },
    plotOptions: { bar: { horizontal: false, columnWidth: '40%', endingShape: 'rounded' } },
    dataLabels: { enabled: false },
    stroke: { show: true, width: 1, colors: ['transparent'] },
    xaxis: {
      categories: daysInMonth,
      labels: { rotate: -45, style: { fontSize: '10px' } }
    },
    yaxis: { labels: { style: { fontSize: '10px' } } },
    fill: { opacity: 1 },
    tooltip: { y: { formatter: val => `${val} Employee` } },
    responsive: [
      { breakpoint: 768, options: { plotOptions: { bar: { columnWidth: '50%' } }, xaxis: { labels: { rotate: -60, style: { fontSize: '9px' } } } } },
      { breakpoint: 480, options: { chart: { height: 300 }, plotOptions: { bar: { columnWidth: '60%' } }, xaxis: { labels: { show: false } } } }
    ]
  };

  const series = [{ name: 'Present', data: presentData }];

  return <Chart options={options} series={series} type="bar" height={300} />;
};

export default AttendanceChart;
